import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { RouterModule } from '@angular/router'
import { LANGUAGE_CODES } from '../../../constants/language'
import { LanguageService } from '../../../services/language.service'
import { TranslationService } from '../../../services/translation.service'
import { Language } from '../../../types/language'
import { FormsModule } from '@angular/forms'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatRadioModule } from '@angular/material/radio'

@Component({
  selector: 'app-language',
  imports: [RouterModule, MatExpansionModule, MatRadioModule, FormsModule],
  templateUrl: './language.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './language.component.scss',
})
export class LanguageComponent implements OnInit {
  translationService = inject(TranslationService)
  private languageService = inject(LanguageService)

  selectedLanguage?: string
  languageInLS?: Language

  get selectedLanguageName(): string | undefined {
    return this.languages.find(
      (language) => language.code === this.selectedLanguage,
    )?.name
  }

  languages: Array<Language> = [
    { name: this.translationService.getEnglishText(), code: LANGUAGE_CODES.EN },
    { name: this.translationService.getFrenchText(), code: LANGUAGE_CODES.FR },
  ]

  languageCodeMap = new Map<string, Language>([
    [
      LANGUAGE_CODES.EN,
      {
        // using translation service for these isn't necessary. these are just being stored in LS - not displayed to the user
        name: 'English',
        code: LANGUAGE_CODES.EN,
      },
    ],
    [
      LANGUAGE_CODES.FR,
      {
        name: 'French',
        code: LANGUAGE_CODES.FR,
      },
    ],
  ])

  ngOnInit(): void {
    this.languageInLS = this.languageService.getLanguageFromLS()
    if (this.languageInLS) {
      this.selectedLanguage = this.languageInLS.code
    } else {
      // if nothing in LS, set default to english
      this.selectedLanguage = LANGUAGE_CODES.EN
      this.changeLanguage()
    }
  }

  /**
   * Changes language to use and store in LS
   */
  changeLanguage() {
    if (this.selectedLanguage) {
      const languageToStore = this.languageCodeMap.get(this.selectedLanguage)
      if (languageToStore) {
        this.languageService.storeLanguageInLS(languageToStore)
        this.languageInLS = languageToStore
        location.reload()
      }
    }
  }
}
